@if (clickedOnSave) {
<div>
  <p class="confirmation-message">
    Wijzigingen zijn opgeslagen, wil je de nieuwe kaart vervangen? Of opnieuw
    beginnen?
  </p>
  <div class="action-buttons">
    <button
      class="btn bergh-btn-secondary text-white mr-2"
      (click)="saveAndclose()"
    >
      Ja
    </button>
    <button class="btn bergh-btn-primary text-white mr-2" (click)="closed()">
      Nee
    </button>
  </div>
</div>
}
<div class="row" [ngClass]="{ 'd-none': showTool }">
  <div class="col-md-5">
    <img
      [src]="oldimgsrc"
      style="width: 128px"
      alt="old map"
      id="oldmap"
      #oldmap
    />
  </div>
  <div class="col-md-5">
    <img
      [src]="newimgsrc"
      style="width: 128px"
      alt="new map"
      id="newmap"
      #newmap
    />
  </div>
  <div class="col-md-2">
    <button (click)="setupCanvas()" class="btn btn-primary">
      Beginnen met vervangen
    </button>
  </div>
</div>
<div class="tool" [ngClass]="{ 'd-none': !showTool }">
  <div class="container-fluid bg-success text-center p-3 shadow-lg">
    <div class="row">
      <div class="col-md-12">
        <div
          class="btn-toolbar"
          role="toolbar"
          aria-label="Toolbar with button groups"
        >
          <div class="btn-group me-2" role="group" aria-label="Move Tools">
            <button
              id="btnup"
              class="btn btn-success border-white"
              (click)="moveup()"
              title="Ga omhoog"
            >
              <i-feather name="chevrons-up"></i-feather>
            </button>
            <button
              id="btndown"
              class="btn btn-success border-white"
              (click)="movedown()"
              title="Naar beneden verplaatsen"
            >
              <i-feather name="chevrons-down"></i-feather>
            </button>
            <button
              id="btnpxup"
              class="btn btn-success border-white"
              (click)="movepxup()"
              title="Ga omhoog per enkele eenheid"
            >
              <i-feather name="chevron-up"></i-feather>
            </button>
            <button
              id="btnpxdown"
              class="btn btn-success border-white"
              (click)="movepxdown()"
              title="Ga per eenheid naar beneden"
            >
              <i-feather name="chevron-down"></i-feather>
            </button>
            <button
              id="btnleft"
              class="btn btn-success border-white"
              (click)="moveleft()"
              title="Ga naar links"
            >
              <i-feather name="chevrons-left"></i-feather>
            </button>
            <button
              id="btnright"
              class="btn btn-success border-white"
              (click)="moveright()"
              title="Ga naar rechts"
            >
              <i-feather name="chevrons-right"></i-feather>
            </button>
            <button
              id="btnpxleft"
              class="btn btn-success border-white"
              (click)="movepxleft()"
              title="Ga naar links per enkele eenheid"
            >
              <i-feather name="chevron-left"></i-feather>
            </button>
            <button
              id="btnpxright"
              class="btn btn-success border-white"
              (click)="movepxright()"
              title="Ga per enkele eenheid naar rechts"
            >
              <i-feather name="chevron-right"></i-feather>
            </button>
          </div>
          <div
            class="btn-group me-2"
            role="group"
            aria-label="Rotate & Scale Tools"
          >
            <button
              id="btnrotate"
              class="btn btn-success border-white"
              (click)="rotate()"
              title="90 graden draaien"
            >
              <i-feather name="rotate-ccw"></i-feather>
            </button>
            <button
              id="zoomin"
              class="btn btn-success border-white"
              (click)="scaleup()"
              title="Vergroot"
            >
              <i-feather name="maximize-2"></i-feather>
            </button>
            <button
              id="zoomout"
              class="btn btn-success border-white"
              (click)="scaledown()"
              title="Schaal naar beneden"
            >
              <i-feather name="minimize-2"></i-feather>
            </button>
          </div>
          <div class="btn-group me-2" role="group" aria-label="Zoom Tools">
            <button
              id="zoomin1"
              class="btn btn-success border-white"
              (click)="zoomin()"
              title="In zoomen
              "
            >
              <i-feather name="zoom-in"></i-feather>
            </button>
            <button
              id="zoomout1"
              class="btn btn-success border-white"
              (click)="zoomout()"
              title="Uitzoomen"
            >
              <i-feather name="zoom-out"></i-feather>
            </button>
          </div>
          <div class="btn-group me-2" role="group" aria-label="Opacity Tools">
            <button
              id="bgalphaup"
              class="btn btn-success border-white"
              (click)="bgalphaup()"
              title="Verhoog de dekking van de achtergrond"
            >
              <i-feather name="corner-right-up"></i-feather>
            </button>
            <button
              id="bgalphadown"
              class="btn btn-success border-white"
              (click)="bgalphadown()"
              title="Verlaag de dekking van de achtergrond"
            >
              <i-feather name="corner-right-down"></i-feather>
            </button>
            <button
              id="fgalphaup"
              class="btn btn-success border-white text-warning"
              (click)="fgalphaup()"
              title="Verhoog de dekking van de voorgrond"
            >
              <i-feather name="corner-right-up"></i-feather>
            </button>
            <button
              id="fgalphadown"
              class="btn btn-success border-white text-warning"
              (click)="fgalphadown()"
              title="Verlaag de dekking van de voorgrond"
            >
              <i-feather name="corner-right-down"></i-feather>
            </button>
          </div>
          <div class="btn-group me-2" role="group" aria-label="Save Tools">
            <button
              id="btnsave"
              class="btn btn-success border-white"
              (click)="save()"
              title="Afbeelding opslaan"
            >
              <i-feather name="save"></i-feather>
            </button>
          </div>
          <div class="btn-group me-2" role="group" aria-label="Map Tools">
            <button
              id="btnnewmapupload"
              class="btn btn-success border-white"
              (click)="newMap()"
              title="Nieuwe kaartupload"
            >
              <i-feather name="play"></i-feather>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="wrapper shadow-lg p-3 mb-5" id="wrapperscaled">
    <canvas
      #background
      id="background"
      width="7020"
      height="4966"
      style="width: 1000px; height: 707px; border: 1px solid red"
    ></canvas>
    <canvas
      #foreground
      id="foreground"
      width="7020"
      height="4966"
      style="width: 1000px; height: 707px"
    ></canvas>
  </div>
</div>

<!-- <div class="modal" id="confirmMapModal" tabindex="-1" role="dialog"> -->
<!-- <div class="modal-overlay-map" *ngIf="clickedOnSave">
<div class="card mx-auto modal-lg border-0">
  <div class="card-header bergh-bg-primary text-white h5">
    Confirm Map Replacement
  </div> -->
<!-- <!-- <div class="modal-dialog modal-xl" role="document">
  <div class="modal-content pr-3 pl-3 pb-3" >
    <div class="modal-header">
      <div
        class="close px-0"
        id="closeBtn"
        data-dismiss="modal"
        aria-label="Close"
        >
        <i-feather name="x" class="small-icon ml-auto"></i-feather>
      </div>
    </div> -->
<!-- </div>
</div> -->
<!-- </div> -->
